import { initApp } from "@multiversx/sdk-dapp/out/methods/initApp/initApp";
import { EnvironmentsEnum } from "@multiversx/sdk-dapp/out/types/enums.types";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { initTelegram } from "./telegram";
import "./styles.css";

initTelegram();

const root = document.getElementById("root");
if (!root) throw new Error("Missing #root");

// sdk-dapp must be initialised before any of its hooks/managers run. nativeAuth
// makes login produce a native-auth token (verified server-side at /auth/login);
// its origin defaults to window.location.origin (must match the server's
// NATIVE_AUTH_ACCEPTED_ORIGINS). Session state is kept in sessionStorage. Our own
// WalletConnect projectId is REQUIRED for xPortal: sdk-dapp's built-in default is
// "" and its strategy rejects that, so the panel's xPortal option becomes a silent
// no-op without one (set VITE_WALLETCONNECT_PROJECT_ID at build time).
const wcProjectId = import.meta.env.VITE_WALLETCONNECT_PROJECT_ID;
if (!wcProjectId) {
  console.warn(
    "[booga] VITE_WALLETCONNECT_PROJECT_ID is empty — xPortal login is disabled (sdk-dapp ships no default projectId).",
  );
}
void initApp({
  storage: { getStorageCallback: () => sessionStorage },
  dAppConfig: {
    nativeAuth: { expirySeconds: 2 * 60 * 60 },
    environment: EnvironmentsEnum.mainnet,
    ...(wcProjectId
      ? { providers: { walletConnect: { walletConnectV2ProjectId: wcProjectId } } }
      : {}),
  },
}).then(() => {
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
